document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.discount-brands-container').forEach(function (container) {
    const buttons = container.querySelectorAll('.discount-filter-button');
    const logos = container.querySelectorAll('.brand-logo-item');

    function updateFilter(selected) {
      buttons.forEach(btn => btn.classList.toggle('active', btn.dataset.discount === selected));
      logos.forEach(logo => {
        const logoDiscount = logo.dataset.discount;
        logo.hidden = logoDiscount !== selected;
      });
    }

    buttons.forEach(button => {
      button.addEventListener('click', function () {
        updateFilter(this.dataset.discount);
      });
    });

    // Set initial state (first button)
    const first = container.querySelector('.discount-filter-button');
    if (first) updateFilter(first.dataset.discount);
  });
});